import { type SelectOption } from '../../../../../components';
import { PAGE_TEXT } from '../lang';
import { ADDITIONAL_DOCS_TYPE } from '../constants';

const additionalDocTypeText = PAGE_TEXT.ADDITIONAL_DOCUMENTS.DOCS_OPTIONS;
const additionalDocTypeKeys: string[] = Object.keys(additionalDocTypeText);

export const additionalDocTypeOptions: SelectOption[] = Object.values(
  additionalDocTypeText,
).map((label: string, index: number) => ({
  value:
    ADDITIONAL_DOCS_TYPE[
      additionalDocTypeKeys[index] as keyof typeof ADDITIONAL_DOCS_TYPE
    ],
  label,
}));
